import { newsletters_the_weekend_path, the_electric_path } from '@routes';

interface TimelineEventData {
  year: string;
  events: {
    title: string;
    description: string;
  }[];
}

export const TIMELINE_DATA: TimelineEventData[] = [
  {
    year: '2013',
    events: [
      {
        title: 'Launch of The Information',
        description: 'Established as a leading platform for in-depth tech journalism.',
      },
    ],
  },
  {
    year: '2014',
    events: [
      {
        title: 'First New York Hire',
        description: 'Expanded the team to strengthen presence on the East Coast.',
      },
    ],
  },
  {
    year: '2015',
    events: [
      {
        title: 'First corporate subscription sold',
        description: 'Secured the first corporate subscription, marking a milestone in growth.',
      },
      {
        title: 'First Subscriber Summit',
        description: 'Launched an event to engage and connect with subscribers.',
      },
    ],
  },
  {
    year: 'August 2016',
    events: [
      {
        title: 'First Organizational Chart',
        description:
          'Created to map key players and relationships in tech, giving subscribers valuable insight into industry power dynamics.',
      },
    ],
  },
  {
    year: 'October 2016',
    events: [
      {
        title: 'First Hire in Asia',
        description: 'Began international expansion with a focus on the Asian market.',
      },
    ],
  },
  {
    year: '2017',
    events: [
      {
        title: 'Opened New York Bureau',
        description: 'Enhanced coverage and reporting capabilities from New York.',
      },
    ],
  },
  {
    year: 'June 2019',
    events: [
      {
        title: 'Launched The Information App',
        description: 'Expanded accessibility with a dedicated mobile app.',
      },
      {
        title: 'First The Information’s WTF Women’s Summit',
        description: 'Introduced a new event series to foster community and discussion.',
      },
    ],
  },
  {
    year: 'April 2020',
    events: [
      {
        title: 'Launched The Briefing Newsletter',
        description: 'Started a newsletter to provide timely insights and updates.',
      },
    ],
  },
  {
    year: 'July 2021',
    events: [
      {
        title: `Launched <a href="${the_electric_path()}">The Electric</a>`,
        description: 'Introduced a new publication focusing on technology and innovation.',
      },
    ],
  },
  {
    year: 'November 2021',
    events: [
      {
        title: `Launched <a href="${newsletters_the_weekend_path()}">The Weekend</a> section`,
        description: 'Started a weekly roundup of key insights and trends.',
      },
    ],
  },
  {
    year: 'September 2022',
    events: [
      {
        title: 'Established Finance Team',
        description: 'Formed a dedicated team to enhance financial coverage.',
      },
    ],
  },
  {
    year: 'February 2023',
    events: [
      {
        title: 'Launched The Information Pro',
        description: 'Introduced a premium subscription service for exclusive content.',
      },
    ],
  },
  {
    year: 'July 2025',
    events: [
      {
        title: 'Launched The Information Deep Research',
        description:
          'Debuted AI-powered answers grounded in over a decade of The Information’s trusted reporting, org charts and data — because AI is only as smart as the data it learns from.',
      },
      {
        title: 'Launched The Information’s TITV',
        description:
          'Introduced a daily streaming show providing the first in tech news and analysis from the people who break and shape the story.',
      },
    ],
  },
];
